import { useQuoteModal } from '../../../context/QuoteModalContext';

export default function BottomCTA() {
  const { openModal } = useQuoteModal();
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-3xl mx-auto text-center px-6">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          Ready to create something unforgettable?
        </h2>
        <p className="text-lg text-gray-500 mb-8">
          Tell us about your event and we&apos;ll recommend the perfect solution.
        </p>
        <button
          type="button"
          onClick={openModal}
          className="inline-block bg-teal-500 hover:bg-teal-600 text-white px-10 py-4 rounded-lg font-bold text-base transition-colors whitespace-nowrap cursor-pointer"
        >
          Inquire Now
        </button>
      </div>
    </section>
  );
}
